import axios from "axios";

/** Open a JWT-protected API PDF in a new tab (tenant/landlord agreement streams). */
export const openAuthPdf = async (url, token) => {
	if (!url) return { success: false, message: "No PDF URL available." };
	try {
		const response = await axios.get(url, {
			responseType: "blob",
			headers: token ? { Authorization: `Bearer ${token}` } : {},
		});
		const blob = new Blob([response.data], { type: "application/pdf" });
		const blobUrl = URL.createObjectURL(blob);
		window.open(blobUrl, "_blank", "noopener,noreferrer");
		setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
		return { success: true };
	} catch (error) {
		const message =
			error?.response?.data?.error ||
			error?.response?.data?.message ||
			error?.message ||
			"Failed to open PDF.";
		return { success: false, message };
	}
};
